import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/layout';
import { ProductCard } from '../components/ProductCard';
import { EmptyState } from '../components/ui';
import { useFavoritesStore } from '../store';
import { api } from '../services/api';
import { Product } from '../types';

export const FavoritesPage: React.FC = () => {
  const navigate = useNavigate();
  const { favoriteIds } = useFavoritesStore();
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadFavorites();
  }, [favoriteIds]);

  const loadFavorites = async () => {
    setIsLoading(true);
    try {
      if (favoriteIds.length === 0) {
        setProducts([]);
        return;
      }
      const favProducts = await api.getFavorites();
      setProducts(favProducts);
    } catch {
      try {
        const res = await api.getProducts({ limit: 5000 });
        setProducts(res.products.filter((p) => favoriteIds.includes(p.id)));
      } catch {
        setProducts([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Layout><div /></Layout>;
  }

  return (
    <Layout>
      <div className="px-4 py-6">
        {/* Header */}
        <div className="mb-5 flex items-baseline justify-between">
          <h1 className="text-2xl font-bold" style={{ fontFamily: 'Manrope, sans-serif', lineHeight: '120%', letterSpacing: '-0.4px', color: '#1A1D1A' }}>Избранное</h1>
          {products.length > 0 && (
            <span className="text-text-secondary" style={{ fontSize: '15px' }}>
              {products.length} {products.length === 1 ? 'товар' : 'товаров'}
            </span>
          )}
        </div>

        {/* Products Grid */}
        {products.length > 0 ? (
          <div className="grid grid-cols-2 gap-3">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                orientation="vertical"
              />
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 220px)' }}>
            <EmptyState
              title="Пока ничего нет"
              description="Добавьте товары в избранное, чтобы быстро находить их позже"
              icon={
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 27L14.26 25.4174C8.08 19.8185 4 16.1139 4 11.594C4 7.88937 6.904 5 10.6 5C12.688 5 14.692 5.97112 16 7.49373C17.308 5.97112 19.312 5 21.4 5C25.096 5 28 7.88937 28 11.594C28 16.1139 23.92 19.8185 17.74 25.4174L16 27Z" fill="#818384"/>
                </svg>
              }
              action={{
                label: 'Перейти в каталог',
                onClick: () => navigate('/catalog'),
              }}
            />
          </div>
        )}
      </div>
    </Layout>
  );
};
